import { Inject, Injectable } from "@angular/core";
import { BrowserStorage } from "../core/storage";
import { DOCUMENT } from "@angular/common";
import { BehaviorSubject, Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class ThemeService {
  private static currentTheme = new BehaviorSubject<string>("midnight");
  static themeChanged$: Observable<string> = ThemeService.currentTheme.asObservable();

  constructor(@Inject(DOCUMENT) private document: Document) {}

  setTheme(theme: string) {
    if (ThemeService.currentTheme.getValue() !== theme) {
      ThemeService.currentTheme.next(theme == undefined || theme == "null" ? "midnight" : theme);
      BrowserStorage.setString("theme", ThemeService.currentTheme.value, false);
    }
    this.document.body.classList.remove("dark-theme", "light-theme", "midnight-theme", "classic-theme");
    if (ThemeService.currentTheme.getValue() == "dark") {
      this.document.body.classList.add("dark-theme");
    } else if (ThemeService.currentTheme.getValue() == "light") {
      this.document.body.classList.add("light-theme");
    } else if (ThemeService.currentTheme.getValue() == "classic") {
      this.document.body.classList.add("classic-theme");
    } else {
      this.document.body.classList.add("midnight-theme");
    }
  }

  static getTheme() {
    return ThemeService.currentTheme.getValue();
  }
}
